export const EVENT_COLOR_DEFAULT = '#dff3e4';

export const EVENT_COLORS = [
  '#dff3e4',
  '#f7e4dc',
  '#ecf6ff',
  '#f4e5ff',
  '#e5e6ff',
  '#e5f9ff',
  '#fbffe5',
  '#fff5e5',
  '#ffe5e5',
  '#ffe5ee',
];
